export default "__VITE_ASSET__DKsBllI9__"